//export { default as equityDetailsDropdownsReducer } from './detailsDropdowns';
export { default as receiveSetsDetailsDropdownsReducer } from './detailsDropdowns';
export { default as equityReducer } from './equity';
export { default as receiveSetsProductsSearchReducer } from './productsSearch';
export { default as equityProductsGuideReducer } from './productsGuide';
export { default as validateProductsReducer } from './validateProducts';
export { default as productTemplatesFilterReducer } from './productsTemplatesFilter';
export { default as consignmentProgressBarReducer } from './progressBar';
export { default as productDetailsReducerReceiveSets } from './productDetails';
export { default as shippingMethodsReducer } from './shippingMethods';
export { default as consignmentShipToAddressReducer } from './shipToAddress';
export { default as shippingBatchAllocation } from './shippingBatchAllocations';
export { default as createSurgeryReducer } from './createSurgery';
export { default as surgeryDetailsReducer } from './surgeryDetails';
export { default as updateSurgeryReducer } from './updateSurgery';
export { default as productTemplatesReducer } from './productTemplates';
export { default as consignmentCommonReducer } from './common';
export { default as equityDetailsReducer } from './equityDetails';
export { default as createEquityReducer } from './createEquity';
export { default as validateAccountReducer } from './validateAccount';
export { default as consignmentBilling } from './consignmentBilling';
export { default as consignmentDetailsReducer } from './consignmentDetails';
export { default as receiveSetsReducer } from './consignment';
export { default as gridDataReducer } from './gridData';
export { default as inventoryReducer } from './inventoryDetails';
export { default as updateConsignmentReducer } from './updateConsignment';
export { default as createConsignmentReducer } from './createConsignment';
export { default as paymentDataReducer } from './paymentData';
export { default as getPricesForItemsConsignmentReducer } from './getPricesForItems';
export { default as receiveSetsListDataReducer } from './receiveSetsListDataReducer';
export { default as createReceiveSetsReducer } from './createReceiveSets';
export {default as receiveSetsProductDetailsReducer} from './productDetails';
